import { z } from '@hono/zod-openapi'
import { serviceProviderCategoriesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertServiceProviderCategory = z.infer<
    typeof zInsertServiceProviderCategory
>
export type SelectServiceProviderCategory = z.infer<
    typeof zSelectServiceProviderCategory
>
export type UpdateServiceProviderCategory = z.infer<
    typeof zUpdateServiceProviderCategory
>
export type QueryServiceProviderCategories = z.infer<
    typeof zQueryServiceProviderCategories
>
export type ColumnsOfServiceProviderCategoriesTable =
    keyof typeof serviceProviderCategoriesTable._.columns

export const zSelectServiceProviderCategory = createSelectSchema(
    serviceProviderCategoriesTable,
)
export const zInsertServiceProviderCategory = createInsertSchema(
    serviceProviderCategoriesTable,
).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateServiceProviderCategory =
    zInsertServiceProviderCategory.partial()
export const zQueryServiceProviderCategories = zInsertServiceProviderCategory
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
